import React from "react";
// import { RouteComponentProps, withRouter } from "react-router-dom";
import Admin from "us.collection.admin";
import { withRouter } from "us.common/wIthRouter";

// interface ICntNonProductionDaysCalendar extends RouteComponentProps {}
interface ICntNonProductionDaysCalendar  {}
const Cnt_NonProductionDaysCalendar: React.FC<ICntNonProductionDaysCalendar> = (
  props
) => {
  return (
    <>{/* <Admin.Components.NonProductionDays.Calendar {...props} /> */}</>
  );
};

export default withRouter(Cnt_NonProductionDaysCalendar);
